export default "__VITE_ASSET__BxQLjBVE__"